<template>
    <div>
        <i 
            class="ml-2 mt-4 md:ml-6 md:mt-6 text-chain icon-md cursor-pointer hover:opacity-75 transition" 
            :class="props.icon"
            @click="goBack">
        </i>
    </div>
</template>

<script setup>
    import urlHandler from '@/composables/urlHandler';
    import { defineProps } from 'vue';

    const props = defineProps({
        path: {
            type: String,
            default: '/'
        },
        params: {
            type: Object,
            default: () => ({})
        },
        icon: {
            type: String,
            default: 'pi pi-chevron-circle-left'
        }
    })

    const goBack = () => {
        urlHandler.redirectAndScroll(props.path, props.params);
    }
</script>